<ng-template [ngIf]="classroom"
             [ngIfThen]="classroomRef"
             [ngIfElse]="classroomLoadingRef">
</ng-template>

<ng-template #classroomRef>
  <ng-container *ngTemplateOutlet="classroomCard"></ng-container>
</ng-template>

<ng-template #classroomLoadingRef>
  <ng-template [ngIf]="loading">
    <ng-container *ngTemplateOutlet="classroomCardPlaceholder"></ng-container>
  </ng-template>

  <ng-template [ngIf]="!loading">
    <ng-container *ngTemplateOutlet="notFound"></ng-container>
  </ng-template>
</ng-template>

<ng-template #classroomCardPlaceholder>
  ...
</ng-template>

<ng-template #classroomCard>
  <app-breadcrumbs displayMode="breadCrumbsOnly"></app-breadcrumbs>
  <div class="classroom" [class.mobile]="deviceService.isMobile()">
    <app-classroom-card [classroom]="classroom"
                        [me]="me"
                        [pins]="pins$ | async">
    </app-classroom-card>
    <div class="classroom-actions">
      <div [class.scroll]="deviceService.isMobile()" class="tabs">
        <div *ngFor="let item of tabs; trackBy: trackByFn" class="categories-item">
          <app-categories-item [displayMode]="'simple'"
                               [link]="link(item)"
                               [panel]="item">
          </app-categories-item>
        </div>
      </div>
      <div class="buttons">
        <on-ui-button *ngIf="classroom?.can?.chat && isAvailableChat"
                      class="transparent no-padding"
                      label="classrooms.classroom-page.buttons.chat"
                      (onclick)="openChat()">
        </on-ui-button>
        <on-ui-button *ngIf="classroom?.can?.schedule_meeting"
                      [attr.data-test]="'new-meeting'"
                      class="transparent no-margin no-padding"
                      label="classrooms.classroom-page.buttons.new-meeting"
                      (onclick)="openMeetingModal()">
        </on-ui-button>
        <on-ui-button *ngIf="classroom?.can?.join"
                      [attr.data-test]="'join-class'"
                      class="primary"
                      [state]="joinState"
                      label="classrooms.classroom-page.buttons.join-class"
                      (onclick)="onClassroomJoin()">
        </on-ui-button>
        <on-ui-button *ngIf="classroom?.user_service_contract?.can?.signup"
                      [attr.data-test]="'signup-user-service-contract'"
                      class="primary"
                      [state]="joinState"
                      label="classrooms.classroom-page.buttons.signup-class"
                      (onclick)="onContractSignup()">
        </on-ui-button>
        <on-ui-button *ngIf="classroom?.user_service_contract?.can?.subscribe"
                      [attr.data-test]="'subscribe-user-service-contract'"
                      class="primary"
                      [state]="joinState"
                      label="classrooms.classroom-page.buttons.subscribe-class"
                      (onclick)="onContractSignup()">
        </on-ui-button>

        <ng-template [ngIf]="false">
        <!--
        DONE_IN_MENU classroom?.can?.edit = /** Могу изменить общие сведения */
        DONE_IN_MENU classroom?.can?.invite = /** Могу пригласить участников */
        TODO classroom?.can?.withdrawInvitation = /** могу отозвать приглашение */
        TODO classroom?.can?.acceptInvitation = /** Могу принять приглашение */
        TODO classroom?.can?.declineInvitation = /** Могу отклонить приглашение */
        DONE classroom?.can?.join = /** Могу присоединиться (по ссылке) */
        DONE_IN_MENU classroom?.can?.leave = /** Могу покинуть */
        TODO classroom?.can?.authJoin = /** Смогу присоединиться (по ссылке) после авторизации */
        TODO classroom?.can?.authPaidJoin = /** Смогу присоединиться (по ссылке) с оплатой после авторизации */
        DONE_IN_MENU classroom?.can?.archive = /** Могу архивировать */
        DONE_IN_MENU classroom?.can?.restore = /** Могу восстановить из архива */
        DONE classroom?.can?.schedule_meeting = /** Могу создать митинг */
        TODO classroom?.can?.manage_content = /** Могу управлять контентом в комнате */
        TODO classroom?.can?.manage_tasks = /** Могу назначать и проверять задания для участников комнаты */
        TODO classroom?.can?.assign_assistant = /** Могу назначать ассистента */
        TODO classroom?.can?.assign_replacement_teacher = /** Могу назначать преподавателя на замену */
        TODO classroom?.can?.join_user_service_contract = /** Могу добавиться к группе учеников в рамках услуги преподавателя */
        TODO classroom?.can?.break_user_service_contract = /** Могу прекратить занятия в рамках услуги преподавателя */
        DONE classroom?.can?.chat = /** Могу пользоваться чатом */
        -->
        </ng-template>
      </div>
    </div>
  </div>

  <div *ngIf="classroom.archived_at && classroom.visit_info?.is_participant"
       class="deleted-classroom" [class.mobile]="deviceService.isMobile()">
    <div class="deleted-classroom-message">
      {{ 'classrooms.classroom.deleted-message' | translate }}
    </div>
  </div>

  <router-outlet></router-outlet>
</ng-template>

<ng-template #notFound>
  <app-content-not-found [title]="'not-found.page-title'"></app-content-not-found>
</ng-template>

<ng-template [ngIf]="meetingModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileMeetingForm"
             [canClose]="false"
             (closed)="closeMeetingModal()">
    <app-modal-body>
      <app-classroom-meeting-form-wrapper [classroom]="classroom"
                                (saved)="onMeetingSaved($event)">
      </app-classroom-meeting-form-wrapper>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="closeMeetingModal()">
      <app-mobile-modal-title>{{ 'lingo2-forms.meetings.form-title' | translate }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-classroom-meeting-form-wrapper [classroom]="classroom"
                                  (saved)="onMeetingSaved($event)">
        </app-classroom-meeting-form-wrapper>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>


<ng-template [ngIf]="inviteModal">
  <app-modal *ngIf="deviceService.isDesktop(); else mobileInviteForm"
             [canClose]="false"
             [middle]="true"
             (closed)="closeInviteModal()">
    <app-modal-body>
      <app-invite-to-classroom [classroom]="classroom"
                               (invited)="onParticipantsInvited($event)">
      </app-invite-to-classroom>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileInviteForm>
    <app-mobile-modal (closed)="closeInviteModal()">
      <app-mobile-modal-title>{{ 'classrooms.invite.title' | translate }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-invite-to-classroom [classroom]="classroom"
                                 (invited)="onParticipantsInvited($event)">
        </app-invite-to-classroom>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>
